import defaultPriceList from './../../data/fencePrices'

const normalizeKey = (value) => {
  return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '')
}

const stripVendorPrefix = (key) => {
  return key.indexOf('AW') === 0 ? key.slice(2) : key
}

const normalizePrices = (prices) => {
  const result = []

  Object.keys(prices || {}).forEach(key => {
    const height = Number.parseInt(key, 10)
    const price = Number.parseFloat(prices[key])

    if (height > 0 && !Number.isNaN(price)) {
      result.push({ height, price })
    }
  })

  return result.sort((a, b) => a.height - b.height)
}

const findByKey = (items, field, key) => {
  if (!key) {
    return null
  }

  const exact = items.find(item => item[field] === key)

  if (exact) {
    return exact
  }

  const prefixed = items.filter(item => {
    if (!item[field] || key.indexOf(item[field]) !== 0) {
      return false
    }
    const next = key.charAt(item[field].length)
    return next === '' || !/[0-9]/.test(next)
  })

  if (prefixed.length === 0) {
    return null
  }

  return prefixed.reduce((longest, item) => item[field].length > longest[field].length ? item : longest)
}

const FencePriceList = class {
  constructor (data) {
    const source = data && data.items && data.items.length > 0 ? data : defaultPriceList

    this.markup = Number.parseFloat(source.markup) || 0
    this.items = (source.items || []).map(item => {
      const key = normalizeKey(item.muster)

      return {
        productId: item.product_id || null,
        key,
        looseKey: stripVendorPrefix(key),
        markup: item.markup === null || typeof item.markup === 'undefined' || item.markup === ''
          ? null
          : Number.parseFloat(item.markup),
        prices: normalizePrices(item.prices)
      }
    }).filter(item => item.prices.length > 0)
  }

  isEmpty () {
    return this.items.length === 0
  }

  findItem (option) {
    if (!option || this.isEmpty()) {
      return null
    }

    if (option.id) {
      const byProduct = this.items.find(item => item.productId === option.id)

      if (byProduct) {
        return byProduct
      }
    }

    const key = normalizeKey(option.name)

    return findByKey(this.items, 'key', key) ||
      findByKey(this.items, 'looseKey', stripVendorPrefix(key))
  }

  getPricePerMeter (option, heightInMillimeters) {
    const item = this.findItem(option)

    if (!item) {
      return null
    }

    const tier = item.prices.find(price => heightInMillimeters <= price.height) ||
      item.prices[item.prices.length - 1]

    const markup = item.markup === null || Number.isNaN(item.markup) ? this.markup : item.markup

    return tier.price * (1 + markup / 100)
  }
}

export default FencePriceList
